module.exports = __webpack_public_path__ + "img/product_9.977b1cf.svg";